import React, { Component} from 'react';

export default class Footer extends Component {
  render() {
    return (
        <div>
            <footer className="text-center pb-3">
            <div className="mb-2">
              <a href="/about" className="text-secondary small text-decoration-none me-3">About</a>
              <a href="/privacy" className="text-secondary small text-decoration-none me-3">Privacy Policy</a>
              <a href="mailto:info@foreignsix.com" className="text-secondary small text-decoration-none">Contact</a>
            </div>
            <p className="mb-0 text-secondary small">Copyright &copy; 2025 - { new Date().getFullYear() } ForeignSix LLC. All rights reserved.</p>
            </footer>
        </div>
    );
  }
}
